"use client"

import * as Sentry from "@sentry/nextjs"
import { useEffect } from "react"
import { isVersionSkewError } from "@/lib/deploy/versionSkew"
import { VersionUpdateScreen } from "@/components/VersionUpdateScreen"

export default function OnlineOrderError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    Sentry.captureException(error, { tags: { zone: "online-order" } })
  }, [error])

  if (isVersionSkewError(error)) return <VersionUpdateScreen />

  return (
    // C-18 (audit 2026-05-27): tokenize from shadcn (text-muted-foreground,
    // bg-primary) which are not wired in the public-order CSS scope.
    <div
      className="flex min-h-screen flex-col items-center justify-center gap-4 p-8 text-center"
      style={{ background: "var(--redy-warm-white)", color: "var(--redy-charcoal)" }}
    >
      <h1 className="text-2xl font-bold">Error al cargar el menú</h1>
      <p className="max-w-md" style={{ color: "var(--redy-secondary)" }}>
        No pudimos cargar el menú en este momento. Por favor intenta de nuevo.
      </p>
      <button
        onClick={reset}
        className="rounded-2xl px-8 py-3 text-[15px] font-black text-white transition-all active:scale-[0.98]"
        style={{
          background: "var(--redy-gradient)",
          boxShadow: "0 8px 24px rgba(215,38,61,0.22)",
        }}
      >
        Reintentar
      </button>
    </div>
  )
}
